<nav class="nav">
  <div class="nav-inner">
    <a routerLink="/home" class="nav-logo" (click)="closeMobMenu()">
      <img src="/logo.webp" alt="TriStar Finance Home Loans" class="nav-logo-img" width="305" height="110">
    </a>

    <div class="nav-links">
      <a routerLink="/prequal" routerLinkActive="active" class="nav-link">Pre-Qualify</a>
      <div class="dd-wrapper" (mouseenter)="calculatorMenuOpen = true" (mouseleave)="calculatorMenuOpen = false">
        <button class="nav-link dd-btn">Calculator <span class="dd-arrow">▼</span></button>
        <div class="dd" [class.dd-open]="calculatorMenuOpen">
          <a routerLink="/calculator/mortgage" (click)="closeMobMenu()">Mortgage Payment Calculator</a>
        </div>
      </div>
      
      <div class="dd-wrapper" (mouseenter)="loanMenuOpen = true" (mouseleave)="loanMenuOpen = false">
        <button class="nav-link dd-btn">Loan Products <span class="dd-arrow">▼</span></button>
        <div class="dd wide" [class.dd-open]="loanMenuOpen">
          <a routerLink="/loans/first-time-home-buyer" (click)="closeMobMenu()">First Time Home Buyer</a>
          <a routerLink="/loans/dscr-loan" (click)="closeMobMenu()">DSCR Loan</a>
          <a routerLink="/loans/refinance" (click)="closeMobMenu()">Refinance</a>
          <a routerLink="/loans/non-qm-loan" (click)="closeMobMenu()">NON-QM Loan</a>
          <a routerLink="/loans/fha-home-loan" (click)="closeMobMenu()">FHA Home Loan</a>
          <a routerLink="/loans/bridge-loan" (click)="closeMobMenu()">Bridge Loan</a>
          <a routerLink="/loans/va-home-loan" (click)="closeMobMenu()">VA Home Loan</a>
          <a routerLink="/loans/cash-offers" (click)="closeMobMenu()">Cash Offers</a>
          <a routerLink="/loans/fixed-rate-mortgage" (click)="closeMobMenu()">Fixed Rate Mortgage</a>
          <a routerLink="/loans/asset-depletion" (click)="closeMobMenu()">Asset Depletion</a>
          <a routerLink="/loans/jumbo-home-loan" (click)="closeMobMenu()">Jumbo Home Loan</a>
          <a routerLink="/loans/bank-statement" (click)="closeMobMenu()">Bank Statement</a>
          <a routerLink="/loans/usda-loan" (click)="closeMobMenu()">USDA Loan</a>
          <a routerLink="/loans/low-down-payment" (click)="closeMobMenu()">Low Down Payment</a>
          <a routerLink="/loans/rehab-loan-203k" (click)="closeMobMenu()">Rehab Loan</a>
      <a routerLink="/loans/forbearance-refi" (click)="closeMobMenu()">Forbearance Refi</a>
          <a routerLink="/loans/investment-property" (click)="closeMobMenu()">Investment Property</a>
          <a routerLink="/loans/adult-family-home" (click)="closeMobMenu()">Adult Family Home</a>
          <a routerLink="/loans/reverse-mortgage" (click)="closeMobMenu()">Reverse Mortgage</a>
                <a routerLink="/loans/primary-residence-construction-loan" (click)="closeMobMenu()">Primary Residence Construction Loan</a>
      <a routerLink="/loans/spec-builder-construction-loan" (click)="closeMobMenu()">Spec Builder Construction Loan</a>
        </div>
      </div>

      <a routerLink="/where-we-lend" routerLinkActive="active" class="nav-link">Where We Lend</a>

      <a routerLink="/heloc" routerLinkActive="active" class="nav-link">HELOC</a>


      <div class="dd-wrapper" (mouseenter)="aboutMenuOpen = true" (mouseleave)="aboutMenuOpen = false">
        <button class="nav-link dd-btn">About <span class="dd-arrow">▼</span></button>
        <div class="dd" [class.dd-open]="aboutMenuOpen">
          <a routerLink="/team" (click)="closeMobMenu()">Team</a>
          <a routerLink="/careers" (click)="closeMobMenu()">Careers</a>
          <a routerLink="/training" (click)="closeMobMenu()">Training</a>
          <a routerLink="/reviews" (click)="closeMobMenu()">Reviews</a>
          <a routerLink="/licensing" (click)="closeMobMenu()">Licensing</a>
          <a routerLink="/partners" (click)="closeMobMenu()">Partners</a>
        </div>
      </div>

      <a routerLink="/calculator/buydown" routerLinkActive="active" class="nav-link">Buy Down Calculator</a>
    </div>

    <div class="nav-right">
      <a href="tel:425-455-8497" class="nav-phone">425-455-8497</a>
      <a href="https://prod.lendingpad.com/tristar-finance-inc-/pos#/account/sign-in" target="_blank" rel="noopener noreferrer" class="nav-login">Client Login</a>
      <a href="https://prod.lendingpad.com/tristar-finance-inc-/pos#/?loid=a8f59110-652e-4b1d-b5e9-4f7d4da8609e" target="_blank" rel="noopener noreferrer" class="nav-cta">Apply Online</a>
      <a href="https://tsftpo.com/" target="_blank" rel="noopener noreferrer" class="nav-login">Partner Portal</a>
    </div>

    <button class="mob-menu-btn" (click)="toggleMobMenu()" aria-label="Toggle navigation menu">
      <span class="ham" [class.ham-open]="mobileMenuOpen"></span>
    </button>
  </div>

  <div class="mob-menu" [class.mob-menu-open]="mobileMenuOpen">
    <div class="mob-inner">
      <a routerLink="/prequal" (click)="closeMobMenu()">Pre-Qualify</a>
      <div class="mob-dd">
        <button class="mob-dd-btn" (click)="toggleCalculatorMenu()">
          Calculator
          <span class="mob-dd-arrow" [class.open]="calculatorMenuOpen">▼</span>
        </button>
        <div class="mob-dd-content" [class.open]="calculatorMenuOpen">
          <a routerLink="/calculator/mortgage" (click)="closeMobMenu()">Mortgage Payment Calculator</a>
        </div>
      </div>
      <div class="mob-dd">
        <button class="mob-dd-btn" (click)="toggleLoanMenu()">
          Loan Products
          <span class="mob-dd-arrow" [class.open]="loanMenuOpen">▼</span>
        </button>
        <div class="mob-dd-content" [class.open]="loanMenuOpen">
          <a routerLink="/loans/first-time-home-buyer" (click)="closeMobMenu()">First Time Home Buyer</a>
          <a routerLink="/loans/dscr-loan" (click)="closeMobMenu()">DSCR Loan</a>
          <a routerLink="/loans/refinance" (click)="closeMobMenu()">Refinance</a>
          <a routerLink="/loans/non-qm-loan" (click)="closeMobMenu()">NON-QM Loan</a>
          <a routerLink="/loans/fha-home-loan" (click)="closeMobMenu()">FHA Home Loan</a>
          <a routerLink="/loans/bridge-loan" (click)="closeMobMenu()">Bridge Loan</a>
          <a routerLink="/loans/va-home-loan" (click)="closeMobMenu()">VA Home Loan</a>
          <a routerLink="/loans/cash-offers" (click)="closeMobMenu()">Cash Offers</a>
          <a routerLink="/loans/fixed-rate-mortgage" (click)="closeMobMenu()">Fixed Rate Mortgage</a>
          <a routerLink="/loans/asset-depletion" (click)="closeMobMenu()">Asset Depletion</a>
          <a routerLink="/loans/jumbo-home-loan" (click)="closeMobMenu()">Jumbo Home Loan</a>
          <a routerLink="/loans/bank-statement" (click)="closeMobMenu()">Bank Statement</a>
          <a routerLink="/loans/usda-loan" (click)="closeMobMenu()">USDA Loan</a>
          <a routerLink="/loans/low-down-payment" (click)="closeMobMenu()">Low Down Payment</a>
          <a routerLink="/loans/rehab-loan-203k" (click)="closeMobMenu()">Rehab Loan</a>
      <a routerLink="/loans/primary-residence-construction-loan" (click)="closeMobMenu()">Primary Residence Construction Loan</a>
      <a routerLink="/loans/spec-builder-construction-loan" (click)="closeMobMenu()">Spec Builder Construction Loan</a>
      <a routerLink="/loans/forbearance-refi" (click)="closeMobMenu()">Forbearance Refi</a>
          <a routerLink="/loans/investment-property" (click)="closeMobMenu()">Investment Property</a>
          <a routerLink="/loans/adult-family-home" (click)="closeMobMenu()">Adult Family Home</a>
          <a routerLink="/loans/reverse-mortgage" (click)="closeMobMenu()">Reverse Mortgage</a>
        </div>
      </div>
      <a routerLink="/where-we-lend" (click)="closeMobMenu()">Where We Lend</a>
      <a routerLink="/heloc" (click)="closeMobMenu()">HELOC</a>
      <a routerLink="/blog" (click)="closeMobMenu()">Blog</a>
      <div class="mob-dd">
        <button class="mob-dd-btn" (click)="toggleAboutMenu()">
          About
          <span class="mob-dd-arrow" [class.open]="aboutMenuOpen">▼</span>
        </button>
        <div class="mob-dd-content" [class.open]="aboutMenuOpen">
          <a routerLink="/team" (click)="closeMobMenu()">Team</a>
          <a routerLink="/careers" (click)="closeMobMenu()">Careers</a>
          <a routerLink="/training" (click)="closeMobMenu()">Training</a>
          <a routerLink="/reviews" (click)="closeMobMenu()">Reviews</a>
          <a routerLink="/licensing" (click)="closeMobMenu()">Licensing</a>
          <a routerLink="/partners" (click)="closeMobMenu()">Partners</a>
        </div>
      </div>
      <a routerLink="/calculator/buydown" (click)="closeMobMenu()">Buy Down Calculator</a>
      <a href="tel:425-455-8497" class="mob-phone">425-455-8497</a>
      <a href="https://prod.lendingpad.com/tristar-finance-inc-/pos#/account/sign-in" target="_blank" rel="noopener noreferrer" class="mob-login">Client Login</a>
      <a href="https://prod.lendingpad.com/tristar-finance-inc-/pos#/?loid=a8f59110-652e-4b1d-b5e9-4f7d4da8609e" target="_blank" rel="noopener noreferrer" class="mob-cta">Apply Online</a>
      <a href="https://tsftpo.com/" target="_blank" rel="noopener noreferrer" class="mob-login">Partner Portal</a>
    </div>
  </div>
</nav>
